<template>
  <div class="seller">
    <!-- 賣家內容 -->
    <div class="seller-wrapper">
      <Split></Split>
      <div class="seller-view">
        <div class="address-wrapper">
          <div class="address-left">
            {{ seller.address }}
          </div>
          <div class="address-right">
            <div class="content"></div>
          </div>
        </div>
        <div class="pics-wrapper" v-if="seller.poi_env" ref="picsView">
          <ul class="pics-list" ref="picsList">
            <li class="pics-item" v-for="imgurl in seller.poi_env.thumbnails_url_list" ref="picsItem">
              <img :src="imgurl" />
            </li>
          </ul>
        </div>
        <div class="safety-wrapper">
          <p>查看食品安全檔案</p>
          <span class="icon-keyboard_arrow_right"></span>
        </div>
      </div>
      <Split></Split>
      <div class="tip-wrapper">
        <div class="delivery-wrapper">
          <p>配送服務：{{ seller.app_delivery_tip }}</p>
        </div>
        <div class="shipping-wrapper">
          <p>配送時間：{{ seller.shipping_time }}</p>
        </div>
      </div>
      <Split></Split>
      <div class="other-wrapper">
        <div class="server-wrapper">
          商家服務
          <div class="poi-server" v-for="item in seller.poi_service">
            <img :src="item.icon" />
            {{ item.content }}
          </div>
        </div>
        <div class="discounts-wrapper">
          <div class="discounts-item" v-for="item in seller.discounts2">
            <div class="icon">
              <img :src="item.icon_url" />
            </div>
            <div class="text">
              {{ item.info }}
            </div>
          </div>
        </div>
      </div>
      <Split class="seller-bottom"></Split>
    </div>
  </div>
</template>
<script>
  import Split from "../Split/Split"
  import BScroll from '@better-scroll/core'
  export default {
    data() {
      return{
        seller:{}
      }
    },
    created(){
            // console.log("獲取數據")

          let that = this
          //通過axios發起get請求
          this.$axios.get('/api/seller')
        .then(function (response) {   //獲取數據
          var dataSource = response.data.data
          if (dataSource.code == 0){
            that.seller = dataSource.data


            // 初始化BScroll
            that.$nextTick(()=> {
              if(that.seller.poi_env.thumbnails_url_list){
                let imgW = that.$refs.picsItem[0].clientWidth
                let marginR = 11
                let width = (imgW + marginR) * that.seller.poi_env.thumbnails_url_list.length


                that.$refs.picsList.style.width = width + "px"
                // 這邊很重要，獲取寬度之後一定要加單位"px"

                that.scroll = new BScroll(that.$refs.picsView,{
                  scrollX: true
                })
              }
            })
          }
        })
        .catch(function (error) {   //出錯處理
          // handle error
          console.log(error)
        })
    },
    components:{
      Split,
      BScroll,
    }
  }
</script>
<style>
  @import url("Seller.css");
</style>



// WEBPACK FOOTER //
// src/components/Seller/Seller.vue